import InstrumentList from './InstrumentList';

export default InstrumentList;
